import PrivateRoute, { Router } from 'components/app-layout/PrivateRoute';

import FieldsGridLayout from './containers/Grid';

export default function FieldLayout() {
  return <Router>
    <PrivateRoute path="/path/fields" component={FieldsGridLayout} />
  </Router>
}
